import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import DefaultRequest from '../containers/DefaultRequest.vue'

import ServiceApply from '../views/ServiceApply.vue'


let routes = [
  {
    path: '/',
    redirect: '',
    name: '',
    component: DefaultRequest,
    children: [
      {
        path: '',
        name: '',
        component: ServiceApply
      }
    ]
  },
];

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes,
  beforeEach: ((to, from, next) => {
    next();
  })
})

router.beforeResolve((to, from, next) => {
  next()
})

export default router;
